








































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IActivity } from "@/types";
import { getInvitationProgress } from "@/api";
import MyFooter from "@/components/Footer.vue";
import Rule from "@/components/Rule.vue";
import ActLeaderboard from "@/components/ActLeaderboard.vue";
import ActRankList from "@/components/ActRankList.vue";
import MyTitle from "@/components/Title.vue";
import { Swipe, SwipeItem } from "vant";

Vue.use(Swipe);
Vue.use(SwipeItem);

@Component({
  components: {
    MyFooter,
    Rule,
    ActLeaderboard,
    MyTitle,
    ActRankList
  },
  created() {
    console.log("excute========");
  }
})
export default class Home extends Vue {
  @Prop({ type: Number, required: true }) actId!: number;
  loading = true;
  activity: IActivity = {
    configurationText: {
      banner: {}
    }
  } as IActivity;
  info: any = {
    detailPageInfo: {},
    rewards: []
  };
  levelMap: Array<string> = ["一", "二", "三", "四", "五"];
  current: any = null;
  isLoaded: boolean = false;
  get bannerStyle() {
    return {
      backgroundImage: `url("${this.info.detailPageInfo.banner}")`
    };
  }
  @Watch("actId", { immediate: true })
  async getMineActivityInfo(actId: number) {
    this.loading = true;
    let res = await getInvitationProgress(actId);
    if (res.rewards && res.rewards.length) {
      // @ts-ignore
      res.rewards.forEach((el, i) => {
        if (el.unlocked == 0 && this.current == null) {
          this.current = i;
        }
      });
    }

    this.info = res;
    this.isLoaded = true;
    console.log("getInvitationProgress", res);
    // this.activity = await getMineActivityInfo(actId);
    if (this.info.detailPageInfo.title) {
      document.title = this.info.detailPageInfo.title;
    }
    // @ts-ignore
    this.$rulePopup({
      value: false,
      rule: this.info.detailPageInfo.rule
    });
    this.loading = false;
  }
  toMy() {
    this.$router.push({ name: "myv2", params: { actId: String(this.actId) } });
  }
}
